import CssBaseline from '@material-ui/core/CssBaseline';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import WindsorApi from './api/WindsorApi';
import AppRoutes from './AppRoutes';
import ApprovalStore from './approvals/ApprovalStore';
import AuthenticationService from './auth/AuthenticationService';
import UserContext from './auth/UserContext';
import MobxContext from './mobx/MobxContext';
import AppHeader from './nav/AppHeader';
import LightTheme from './themes/soho/LightTheme';
import DarkTheme from './themes/soho/DarkTheme';
import { SnackbarProvider } from 'notistack';
import PreferenceStore from './preferences/PreferenceStore';
import EnvironmentStore from './environments/EnvironmentStore';
import FamilyStore from './families/FamilyStore';
import ExecutionStore from './families/executions/ExecutionStore';
import CspGroupStore from './common/CspGroupStore';
import { useObserver } from 'mobx-react-lite';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      padding: theme.spacing(3)
    }
  }),
);

interface Props {
  authService: AuthenticationService;
}

const windsorApi = new WindsorApi();
const preferenceStore = new PreferenceStore();

function App(props: Props) {
  const classes = useStyles({});
  const [user, setUser] = useState();

  useEffect(() => {
    windsorApi.getCurrentUser().then(res => {
      setUser({ ...res, ...props.authService.getCurrentUser() });
    });
  }, [props.authService]);

  return useObserver(() => (
    <ThemeProvider theme={preferenceStore.theme === 'light' ? LightTheme : DarkTheme}>
      <CssBaseline />
      {user && <UserContext.Provider value={user}>
        <MobxContext.Provider value={{
          approvalStore: new ApprovalStore(user, windsorApi),
          familyStore: new FamilyStore(user, windsorApi),
          cspGroupStore: new CspGroupStore(windsorApi),
          environmentStore: new EnvironmentStore(windsorApi),
          executionStore: new ExecutionStore(windsorApi),
          preferenceStore,
        }}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider maxSnack={3}>
              <div className={classes.root}>
                <AppHeader />
                <main className={classes.content}>
                  <div className={classes.toolbar} />
                  <AppRoutes authService={props.authService} />
                </main>
              </div>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </MobxContext.Provider>
      </UserContext.Provider>}
    </ThemeProvider>
  ));
}

export default App;
